import { Dialog, DialogContentText, IconButton, useMediaQuery } from "@mui/material";
import createStyles from "@mui/styles/createStyles";
import makeStyles from "@mui/styles/makeStyles";
import React from "react";
import MuiDialogContent from "@mui/material/DialogContent";
import MuiDialogTitle from "@mui/material/DialogTitle";
import { Close } from "@mui/icons-material";
import { verbalTheme } from "../layout/themes/verbal.theme";

type SubscriptionContactDialogProps = {
    open: boolean;
    setOpen: (open: boolean) => void;
};

export const SubscriptionContactDialog = (props: SubscriptionContactDialogProps): JSX.Element => {
    const { open, setOpen } = props;
    const fullScreen = useMediaQuery(verbalTheme.breakpoints.down("lg"));

    const useStyles = makeStyles(
        createStyles({
            closeButton: {
                position: "absolute",
                right: verbalTheme.spacing(1.5),
                top: verbalTheme.spacing(1.5),
                color: verbalTheme.palette.grey[500],
            },
        }),
    );

    const classes = useStyles();

    return (
        <Dialog open={open} onClose={() => setOpen(false)} fullScreen={fullScreen}>
            <MuiDialogTitle>
                <IconButton className={classes.closeButton} onClick={() => setOpen(false)} size="large">
                    <Close />
                </IconButton>
            </MuiDialogTitle>
            <MuiDialogContent>
                <DialogContentText>
                    Please contact your Administrator for Account Subscription Information{" "}
                </DialogContentText>
            </MuiDialogContent>
        </Dialog>
    );
};
